export const JOB_DESCRIPTIONS: any = [
    {
        show: false,
        link: "https://www.linkedin.com/jobs/view/3026068898",
        id: "lead_game_designer",
        name: 'Lead Game Designer',
        markdown: `
Trailblazer Games is on a mission to lead the biggest transformational wave ever seen in gaming. Do you, like us, believe that blockchain will bring new experiences never before seen or imagined in gaming?

We design and build games that fairly distribute the value created between community, developers, and investors, creating real-life value through true ownership of assets and a distributed revenue share model. 

With more than $8 million in funding from leading investors like Play Ventures, Makers Fund and Fabric Ventures, our fully remotely working team is looking for an experienced **Lead Game Designer** to join our rapidly growing organization.

This role will have a major impact on the products on offer by the company, including being pivotal for setting direction of future products. As **Lead Game Designer** you will also interface directly with the community of thousands of users already excited by the project. Never before have the end-users been this close at hand, reducing guess work in all design and product decisions.

As **Lead Game Designer**, you'll work closely with the company leadership and with developers, artists, and producers in cross-functional teams to evolve the game. You’ll be a foundational member of a team that’s working on bringing a portfolio of innovative new games to market.

We are mainly based in Sweden, France and Germany, but you can work remotely from anywhere close enough to our time zone.

###As a Lead Game Designer you’ll get to:

- Push the boundaries of game design by evolving new models suitable to Web3, shaping the future of gaming.
- Build an immersive world where players thrive.
- Execute on our road map while heavily influencing the direction and expression of the company vision.
- Help build the team needed for developing and growing our products.
- Articulate the vision for our product suite and funnel that into executable directions for our dev teams.
- Assess the right KPIs and metrics that should inform the next steps for the game.
- Learn and develop every day in the fastest developing space of gaming in decades.
- Work in a fully remote environment.

###We expect you to achieve this through:

- Excellent design documentation skills.
- Working closely with other disciplines, gathering input form developers and stakeholders to balance design requirements.
- An inclination towards communication, inclusion, and visibility.
- Owning features and systems that you have designed end-to-end.
- Interacting with the community, do AMAs and be an advocate for the dev team and the company vision.
- Organizing playtests and actively gathering feedback from the community.
- Designing and implementing games with an infinite games as a service mindset.
- Experience owning a project from concept to production, including proposal, discussion, and execution.
- Being self-motivated and self-managing, with excellent organizational skills.

###Your experience should include:

- 5+ years of experience in game development.
- 3+ years of mobile and/or F2P game design experience.
- 2+ years of experience leading and/or mentoring other game designers.

###You might also have:

- Experience with or interest in blockchain technology.
- Auto chess or MOBA experience. City builder and 4X-game experience are also a plus.
- A working knowledge of Unity.
- An analytical mindset, used to working with business analysts and product managers.
- Passion for inspiring others and making them passionate about your vision.
- A love for high quality user experience.
- Agile or team leadership experience.
- Experience in product management.
- A strong belief in the promise of blockchain games and a desire to shape the future.

###What you’ll love about Trailblazer:

- At Trailblazer we have an open environment with a flat hierarchy that makes it easy to communicate with all parts of the team.
- You’ll join an environment with a highly motivated and experienced team.
- You’ll be part of shaping the future of gaming, by being at the cutting edge of development.
- The team is working fully remote.
- We offer a competitive compensation package.
- High upside potential through additional compensation options in tokens.

###Learn more:

- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;" href="https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/">https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://eternaldragons.com/whitepaper">https://eternaldragons.com/whitepaper</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://elitegamedevelopers.com/alex-arias-and-andreas-risberg-game-devs-going-web3/">Elite Game Developers podcast</a>
`
    },
    {
        show: false,
        link: "",
        id: "game_designer",
        name: "Game Designer",
        markdown: `
Trailblazer Games is on a mission to lead the biggest transformational wave ever seen in gaming. Do you, like us, believe that blockchain will bring new experiences never before seen or imagined in gaming?

We design and build games that fairly distribute the value created between community, developers, and investors, creating real-life value through true ownership of assets and a distributed revenue share model.

With more than $8 million in funding from leading investors like Play Ventures, Makers Fund and Fabric Ventures, our fully remotely working team is looking for a **Game Designer** to join our rapidly growing organization.

This role is pivotal for the execution and delivery of our first game, with two more games planned for the near future. As **Game Designer** you will also interface directly with the community of thousands of users already excited by the project. Never before have the end-users been this close at hand, reducing guess work in all design and product decisions.

As **Game Designer**, you'll work directly with developers, artists, and producers in cross-functional teams to evolve the game. You’ll be a foundational member of a team that’s working on bringing an innovative new game to market.

We are mainly based in Sweden, France and Germany, but you can work remotely from anywhere close enough to our time zone.

###As a Game Designer you’ll get to:

- Push the boundaries of game design by evolving new models suitable to Web3, shaping the future of gaming.
- Be part of building an immersive world where players thrive.
- Execute on our road map while heavily influencing the in-game execution of the creative vision.
- Design features and systems and package them into executable directions for our dev teams.
- Assess the right KPIs and metrics that should inform the next steps for the game.
- Learn and develop every day in the fastest developing space of gaming in decades.
- Work in a fully remote environment.

###We expect you to achieve this through:

- Excellent design documentation skills.
- Working closely with other disciplines, gathering input form developers and stakeholders to balance design requirements.
- An inclination towards communication, inclusion, and visibility.
- Owning features and systems that you have designed end-to-end.
- Interacting with the community, do AMAs and be an advocate for the dev team and the company vision.
- Organizing playtests and actively gathering feedback from the community.
- Designing and implementing games with an infinite games as a service mindset.
- Being self-motivated and self-managing, with excellent organizational skills.

###Your experience should include:

- 3+ years of experience in game development.
- 2+ years of mobile and/or F2P game design experience.

###You might also have:

- Experience with or interest in blockchain technology.
- Auto chess or MOBA experience.
- A working knowledge of Unity.
- An analytical mindset, used to working with business analysts and product managers.
- Passion for inspiring others and making them passionate about your vision.
- A love for high quality user experience.
- Experience working in an agile team context.
- A strong belief in the promise of blockchain games and a desire to shape the future.

###What you’ll love about Trailblazer:

- At Trailblazer we have an open environment with a flat hierarchy that makes it easy to communicate with all parts of the team.
- You’ll join an environment with a highly motivated and experienced team.
- You’ll be part of shaping the future of gaming, by being at the cutting edge of development.
- The team is working fully remote.
- We offer a competitive compensation package.
- High upside potential through additional compensation options in tokens.

###Learn more:

- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;" href="https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/">https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://eternaldragons.com/whitepaper">https://eternaldragons.com/whitepaper</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://elitegamedevelopers.com/alex-arias-and-andreas-risberg-game-devs-going-web3/">Elite Game Developers podcast</a>

`
    },
    {
        show: true,
        link: "https://www.linkedin.com/jobs/view/3032993304",
        id: "backend_engineer",
        name: "Backend Engineer",
        markdown: `
Trailblazer Games is on a mission to lead the biggest transformational wave ever seen in gaming. Do you, like us, believe that blockchain will bring new experiences never before seen or imagined in gaming?

We design and build games that fairly distribute the value created between community, developers, and investors, creating real-life value through true ownership of assets and a distributed revenue share model.

With more than $8 million in funding from leading investors like Play Ventures, Makers Fund, and Fabric Ventures, our fully remotely working team is looking for an experienced **Backend Engineer** to join our rapidly growing organization.

This role is pivotal for the execution and delivery of our first game, with two more games already planned within the same franchise. As a **Backend Engineer**, you will have the opportunity to work on new projects that will enhance the user experience in our Web3 games.

We are mainly based in Sweden, France, and Germany, but you can work remotely from anywhere close enough to our time zone.

###As a Backend Engineer you’ll get to:

- Develop features and improvements to the game, the platform, and the data pipeline in a secure, well-tested, and performant way.
- Collaborate with Product Management and other stakeholders to maintain a high bar for quality in a fast-paced, iterative environment.
- Craft code that meets our internal standards for style, maintainability, and best practices for a high-scale web environment. Maintain and advocate for these standards through code review.
- Advocate for improvements to product quality, security, and performance.
- Recognize impediments to our efficiency as a team and propose and implement solutions.
- Ship features and improvements with minimal guidance and support from other team members.

###We expect you to achieve this through:

- Excellent coding skills, clear understanding of design patterns and various programming paradigm
- Feeling comfortable working in a highly agile, intensely iterative software development process.
- Owning features and systems that you have designed end-to-end.
- An inclination towards communication, inclusion, and visibility.
- Experience owning a project from concept to production, including proposal, discussion, and execution.
- Being self-motivated and self-managing, with excellent organizational skills.

###Your experience should include:

- 3+ in backend development, preferably in Typescript/Node, Java or Rust
- 3+ years of experience in cloud development, preferably AWS

###What you’ll love about Trailblazer:

- At Trailblazer we have an open environment with a flat hierarchy that makes it easy to communicate with all parts of the team.
- You’ll be part of shaping the future of gaming, by being at the cutting edge of development.
- The team is working fully remotely.
- You’ll join an environment with a highly motivated and experienced team.
- We offer a competitive compensation package.
- High upside potential through additional compensation options in tokens.

###Learn more:

- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;" href="https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/">https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://eternaldragons.com/whitepaper">https://eternaldragons.com/whitepaper</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://elitegamedevelopers.com/alex-arias-and-andreas-risberg-game-devs-going-web3/">Elite Game Developers podcast</a>
       
        `,
    },
    {
        show: false,
        link: "",
        id: "economy_designer",
        name: "Economy Designer",
        markdown: `
Trailblazer Games is on a mission to lead the biggest transformational wave ever seen in gaming. Do you, like us, believe that blockchain will bring new experiences never before seen or imagined in gaming?

We design and build games that fairly distribute the value created between community, developers, and investors, creating real-life value through true ownership of assets and a distributed revenue share model.

With more than $8 million in funding from leading investors like Play Ventures, Makers Fund and Fabric Ventures, our fully remotely working team is looking for an experienced **Economy Designer** to join our rapidly growing organization.

This role will have a major impact on the products on offer by the company, including being pivotal for making the whole product portfolio sustainable, rewarding and fun for players. The **Economy Designer** will not only work on the in-game economies across the product portfolio, but will also be responsible for the tokenomics design of the whole ecosystem.

As **Economy Designer**, you'll work closely with the company leadership and with the Lead Game Designer to evolve all our games. You’ll be a foundational member of a team that’s working on bringing a portfolio of innovative new games to market.

We are mainly based in Sweden, France and Germany, but you can work remotely from anywhere close enough to our time zone.

###As a Economy Designer you’ll get to:

- Push the boundaries of blockchain and game development by evolving new models suitable to Web3, shaping the future of gaming.
- Help validate ideas and assumptions through creating game economy models and simulations and evaluate their performance and help improve the player experience.
- Execute on our road map while heavily influencing the direction and implementation of the economy as it relates to the company vision.
- Work closely with the Lead Game Designer and inform creative decisions through pinpoint analysis of the game economy effects of design decisions.
- Assess the depth of the economy and propose variations in systems to improve them.
- Assess the right KPIs and metrics that should inform the next steps for the game.
- Learn and develop every day in the fastest developing space of gaming in decades.
- Work in a fully remote environment.

###We expect you to achieve this through:

- A superior understanding of game economies and the design of in-game currencies, items and crafting systems etc.
- An inclination towards communication, inclusion, and visibility.
- Having the ability to narrow the systems to a manageable and balanceable set.
- A good understanding of Tokenomics.
- Significant experience in analytics and predictive analysis.
- A deep understanding of progression systems.
- Excellent design documentation skills.
- Working closely with other designers and company leadership.
- Being pedagogical when presenting analysis and reasoning for advice on systems design.
- Designing systems with an infinite games as a service mindset, while being passionate about creating the best user experience possible.
- Being self-motivated and self-managing, with excellent organizational skills.

###Your experience should include:

- 2+ years of experience in game economy, analytics or product management.
- Proficiency in relevant programming languages.
- Understanding and appreciation of tokenomics and blockchain opportunities.

###You might also have:

- A background in economics.
- A good understanding of NFTs and the impact of NFT marketplaces on game economies.
- A passion for blockchain.
- Experience working with F2P economies.
- Auto chess or MOBA experience. City builder and 4X-game experience are a big plus.
- A love for high quality user experience.
- A strong belief in the promise of blockchain games and a desire to shape the future.

###What you’ll love about Trailblazer:

- At Trailblazer we have an open environment with a flat hierarchy that makes it easy to communicate with all parts of the team.
- You’ll join an environment with a highly motivated and experienced team.
- You’ll be part of shaping the future of gaming, by being at the cutting edge of development.
- The team is working fully remote.
- We offer a competitive compensation package.
- High upside potential through additional compensation options in tokens.

###Learn more:

- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;" href="https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/">https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://eternaldragons.com/whitepaper">https://eternaldragons.com/whitepaper</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://elitegamedevelopers.com/alex-arias-and-andreas-risberg-game-devs-going-web3/">Elite Game Developers podcast</a>

`
    },
    {
        show: true,
        link: "https://www.linkedin.com/jobs/view/2988468720",
        id: "unity_developer",
        name: "Unity Developer",
        markdown: `

Do you believe that blockchain will bring new experiences to gaming?

Don’t let this unique opportunity pass. Our Startup, co-founded by a strong team of serial entrepreneurs in the gaming and blockchain industry, is looking for an **Unity Developer** to join the game development team.

We are experiencing one of the biggest transformational waves ever seen in gaming. Players anywhere in the world will play as a way of living with unlimited upside thanks to a new global economy that is being built right now.

Join early and ride this wave with us.

As a **Unity Developer**, you'll work closely with designers, artists, and product managers in cross-functional teams to develop gameplay features. You’ll be a foundational member of a team that’s working on bringing an innovative new game to market.

We are based in Sweden, but you can work remotely from anywhere close enough to our time zone.

###Your responsibilities will be to:

- Be part of the development process and contribute improvements and suggestions, driving the quality of the code throughout the entire production cycle
- Help maintain code, product, and process quality
- Partner with Art, Design and Production teams to ensure schedules and goals meet business and project needs
- Conduct code reviews and enforce best practices
- Bring meaningful contributions to our product and the entire team
        
###Learn more:

- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;" href="https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/">https://venturebeat.com/2022/03/18/trailblazers-raises-8-2m-for-eternal-dragons-blockchain-game/</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://eternaldragons.com/whitepaper">https://eternaldragons.com/whitepaper</a>
- <a style="word-break: break-word; color: #344bc1; text-decoration: underline;"  href="https://elitegamedevelopers.com/alex-arias-and-andreas-risberg-game-devs-going-web3/">Elite Game Developers podcast</a>

`
    }
]